// Func = limiting Scope for this file
//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;


(function(){
	//menu gallery
	menuLinksInteraction();

	$(document).ready(function () {
		

		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			// let navIndex = $(this).index();
			// $('.nav-custom__image').removeClass('active');
			// $('#nav-gallery-' + navIndex).addClass('active');

			$('ul.submenu',this).fadeIn(200);

		}, function(){
			$(this).removeClass("hover");
			
			$('ul.submenu',this).fadeOut(200);
		});

		//-- IS ELEMENT IN VIEW? --//
		const animateHTML = function () {
			let elems,
				windowHeight;
			let init = function () {
				elems = document.getElementsByClassName('img-zoom');
				windowHeight = window.innerHeight;
				addEventHandlers();
			};
			let addEventHandlers = function () {
				window.addEventListener('scroll', checkPosition);
				window.addEventListener('resize', init);
			};
			let checkPosition = function () {
				for (let i = 0; i < elems.length; i++) {
					let posFromTop = elems[i].getBoundingClientRect().top;
					if (posFromTop - windowHeight <= 0) {
						// elems[i].style.transform = 'scale('+ (1 + (window.scrollY /(document.documentElement.offsetHeight * 1.5 - windowHeight))) +')';
					}
				}
			};
			return {
				init: init
			}
		};
		animateHTML().init();


		//-- NAVIGATION & BOOKING --//
		const navTrigger = document.getElementById('nav-trigger');
		const navTriggerTag = document.getElementById('nav-tag');
		const navCustom = document.getElementById('nav-custom');
		const html = document.documentElement; 
		const navHideElements = document.getElementsByClassName('nav-hide');
		const bookTrigger = document.getElementById('booking-trigger');
		const bookClose = document.getElementById('booking-close-trigger');
		const bookCustom = document.getElementById('booking-widget-custom');

		navTrigger.onclick = function() {
			navTrigger.classList.toggle('active');
			navCustom.classList.toggle('active');
			bookTrigger.classList.toggle('dark');
			html.classList.toggle('pause-scroll');

			if(navTriggerTag.innerHTML == "Menu") {
				navTriggerTag.innerHTML = "Close";

			} else {
				navTriggerTag.innerHTML = "Menu";
			}

			for (var i = 0; i < navHideElements.length; i++) {
				navHideElements[i].classList.toggle('active');
			}

			// $('.privary-navigation__list').slick({
			// 	accessibility: true,
			// 	arrows: false,
			// 	autoplay: true,
			// 	autoplaySpeed: 3000,
			// 	centerMode: true,
			// 	dots: true,
			// 	infinite: true,
			// 	pauseOnHover: false,
			// 	slidesToShow: 5,
			// 	slidesToScroll: 1,
			// 	speed: 700, 
			// 	responsive: [
			// 		{
			// 			breakpoint: 1500,
			// 			settings: {
			// 				slidesToShow: 4
			// 			}
			// 		},
			// 		{
			// 			breakpoint: 1200,
			// 			settings: {
			// 				slidesToShow: 3
			// 			}
			// 		}
			// 	]
			// });
		}

		bookTrigger.onclick = function() {
			bookCustom.classList.add('active');
			html.classList.add('pause-scroll');
		}

		bookClose.onclick = function() {
			bookCustom.classList.remove('active');
			html.classList.remove('pause-scroll');
		}

		

		//-- IMAGE(S) ZOOM ON SCROLL --//
		// const pageHeight = document.documentElement.offsetHeight * 1.5;
		// const homePageHeight = document.documentElement.offsetHeight * 2;
		// const heroSlide = document.querySelectorAll('.hero__slide-inner');
		// const homeSlide = document.querySelectorAll('.hero__image-inner');
		// // const amThumb = document.querySelectorAll('.amenities__image-inner div');

		// window.addEventListener('scroll', function() {
		// 	const scrolled = 1 + (window.scrollY / ( pageHeight - window.innerHeight ));
		// 	const scrolledHome = 1 + (window.scrollY / ( homePageHeight - window.innerHeight ));

		// 	for(var i = 0; i < heroSlide.length; i++) {
		// 		heroSlide[i].style.transform = 'scale('+ scrolled +')';
		// 	}

		// 	for(var i = 0; i < homeSlide.length; i++) {
		// 		homeSlide[i].style.transform = 'scale('+ scrolledHome +')';
		// 	}

		// 	// for(var i = 0; i < amThumb.length; i++) {
		// 	// 	amThumb[i].style.transform = 'scale('+ scrolled +')';
		// 	// }
		// });


		//-- PARALLAX EFFECTS --//
		var scrollParallax = []
		var scrolled = 0

		// screen height
		var v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") // get it from html
			//get distance in positive value
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				//get distance in negative value (to do the scroll inverse)
				distance = distance * -1
			}
			//Equivalent distance using screen height + element height
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0
			let topElement = 0;
			let element = elm;
			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				//Obtain the distance between top screen and document top 0
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				//Distance of bottom page to top of the element
				let relative_distance = scrolled + v_height - topElement
				//transpoling data to move the parallax element relative to the scroll of all the screen
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, // relative to document viewport
				rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				threshold: 0 // visible amount of item shown in relation to root
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}


	});

	

}());

function menuLinksInteraction(){
	if(document.getElementsByClassName('nav-custom__image').length > 0){
		//ini
		let ini = 0;
		let allPrimaryA = document.getElementById('primary-nav').getElementsByTagName('a');
		let allGalleryI = document.getElementsByClassName('nav-custom__image');
		for(let i = 0;i < allPrimaryA.length; i++ ){
			if(allPrimaryA[i].classList.contains('active')){
				allGalleryI[i].classList.add('active');
				ini = 1;
			}
		}
		if(ini == 0){
			allGalleryI[0].classList.add('active');
		} 
		//hover
		for(let i = 0;i < allPrimaryA.length; i++ ){
			allPrimaryA[i].addEventListener('mouseenter', function(e){
				for(let j = 0;j < allGalleryI.length; j++){
					allGalleryI[j].classList.remove('active')
				}
				allGalleryI[i].classList.add('active')
			})
		}
	}
	
}
